/* Eisfit: menu, carrosséis, passos, vídeo, avaliações, escolha de cores dos kits, galeria, pacotes, quantidade e barra fixa */
document.addEventListener('DOMContentLoaded', function () {
  var d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* menu do celular */
  var burger = $('[data-menu-toggle]'), menu = $('[data-mobile-menu]');
  function closeMenu() {
    menu.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Abrir menu');
  }
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
    });
    menu.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) { closeMenu(); } });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) { closeMenu(); burger.focus(); }
    });
  }

  /* escolha de cor dos kits */
  function syncGroup(group) {
    var checked = group && group.querySelector('input.ek-input:checked');
    if (!checked) { return; }
    var root = group.closest('[data-ek]'), idx = group.getAttribute('data-ek-group');
    var kase = root && root.querySelector('[data-ek-case="' + idx + '"]');
    var label = root && root.querySelector('[data-ek-label="' + idx + '"]');
    var name = group.querySelector('[data-ek-name]'), mini = group.querySelector('[data-ek-mini]');
    var holder = root && root.querySelector('[data-ek-photo="' + idx + '"]');
    if (holder) {
      /* cor com foto real: troca a foto da case; sem foto, volta o desenho */
      var src = checked.getAttribute('data-photo'), item = holder.parentNode, pic = holder.querySelector('img');
      if (src) {
        if (!pic) { pic = d.createElement('img'); pic.alt = ''; holder.appendChild(pic); }
        if (pic.getAttribute('src') !== src) { pic.removeAttribute('srcset'); pic.removeAttribute('sizes'); pic.setAttribute('src', src); }
        item.classList.add('has-photo');
      } else { item.classList.remove('has-photo'); }
    }
    if (kase) { kase.style.setProperty('--c', checked.getAttribute('data-color')); }
    if (label) { label.textContent = checked.value; }
    if (name) { name.textContent = checked.value; }
    if (mini) { mini.style.setProperty('--c', checked.getAttribute('data-color')); }
  }
  $$('[data-ek-group]').forEach(syncGroup);
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('ek-input')) { syncGroup(t.closest('[data-ek-group]')); }
  });

  /* galeria do produto + ampliar */
  var lb = $('[data-lb]'), lbBody = lb && $('[data-lb-body]', lb), lbGal = null, lbI = 0;
  function lbShow(g, n) {
    var sl = $$('.gal-slide', g);
    lbGal = g; lbI = (n + sl.length) % sl.length;
    var s = sl[lbI], big = s.getAttribute('data-big'), svg = s.querySelector('svg');
    lbBody.innerHTML = big ? '<img src="' + big + '" alt="' + (s.getAttribute('data-alt') || '') + '">' : (svg ? svg.outerHTML : '');
    if (!lb.open) { lb.showModal(); }
  }
  if (lb) {
    $('[data-lb-x]', lb).addEventListener('click', function () { lb.close(); });
    $('[data-lb-p]', lb).addEventListener('click', function () { lbShow(lbGal, lbI - 1); });
    $('[data-lb-n]', lb).addEventListener('click', function () { lbShow(lbGal, lbI + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbBody.parentNode) { lb.close(); } });
  }
  $$('[data-gal]').forEach(function (g) {
    var tr = $('[data-gal-track]', g), sl = $$('.gal-slide', tr), th = $$('[data-gal-th]', g), cnt = $('[data-gal-count]', g), cur = 0;
    function go(n) { n = (n + sl.length) % sl.length; tr.scrollTo({ left: n * tr.clientWidth, behavior: 'smooth' }); }
    function mark(n) {
      cur = n;
      th.forEach(function (b, k) { b.setAttribute('aria-current', k === n ? 'true' : 'false'); });
      if (cnt) { cnt.textContent = (n + 1) + ' / ' + sl.length; }
    }
    tr.addEventListener('scroll', function () {
      var n = Math.round(tr.scrollLeft / (tr.clientWidth || 1));
      if (n !== cur && n >= 0 && n < sl.length) { mark(n); }
    }, { passive: true });
    var p = $('[data-gal-prev]', g), n = $('[data-gal-next]', g), z = $('[data-gal-zoom]', g);
    if (p) { p.addEventListener('click', function () { go(cur - 1); }); }
    if (n) { n.addEventListener('click', function () { go(cur + 1); }); }
    th.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    if (z && lb) { z.addEventListener('click', function () { lbShow(g, cur); }); }
    if (lb) { sl.forEach(function (s, k) { s.addEventListener('click', function () { lbShow(g, k); }); }); }
    mark(0);
  });

  /* pacotes (1 toalha, Duo, Família) */
  $$('[data-bundle]').forEach(function (b) {
    var scope = b.parentNode;
    function sync() {
      var v = (b.querySelector('input:checked') || {}).value;
      $$('.bd', b).forEach(function (l) { l.classList.toggle('is-on', !!l.querySelector('input:checked')); });
      $$('[data-panel]', scope).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== v; });
    }
    b.addEventListener('change', sync);
    sync();
  });

  /* quantidade */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q]');
    if (!b) { return; }
    var i = b.parentNode.querySelector('input'), v = (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-q'), 10);
    i.value = Math.min(99, Math.max(1, v));
  });

  /* barra fixa de compra (celular) */
  var bar = $('[data-sticky]'), target = $('[data-sticky-t]');
  if (bar && target) {
    var queued = false;
    var checkBar = function () {
      queued = false;
      bar.classList.toggle('is-on', target.getBoundingClientRect().bottom < 0);
    };
    var queueBar = function () {
      if (!queued) { queued = true; (window.requestAnimationFrame || window.setTimeout)(checkBar); }
    };
    window.addEventListener('scroll', queueBar, { passive: true });
    window.addEventListener('resize', queueBar);
    checkBar();
    $('[data-sticky-go]', bar).addEventListener('click', function () {
      var f = $('#single-form'), p1 = $('[data-panel="1"]');
      if (f && p1 && !p1.hidden) { if (f.requestSubmit) { f.requestSubmit(); } else { f.submit(); } }
      else { (target.scrollIntoView ? target : d.body).scrollIntoView({ behavior: 'smooth' }); }
    });
  }
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* carrosséis: cartão do meio em destaque, setas no computador, pontinhos no celular */
  $$('[data-car]').forEach(function (car) {
    var tr = $('[data-car-track]', car), items = tr ? $$('.car-i', tr) : [];
    if (!tr || !items.length) { return; }
    var prev = $('[data-car-prev]', car), next = $('[data-car-next]', car), dots = $('[data-car-dots]', car), act = -1, queued = false, dotEls = [];
    car.classList.add('is-js');
    if (dots) {
      dots.innerHTML = items.map(function () { return '<i></i>'; }).join('');
      dotEls = $$('i', dots);
    }
    function mark() {
      queued = false;
      var c = tr.scrollLeft + tr.clientWidth / 2, best = 0, bd = Infinity;
      items.forEach(function (it, k) {
        var dd = Math.abs(it.offsetLeft + it.offsetWidth / 2 - c);
        if (dd < bd) { bd = dd; best = k; }
      });
      if (best !== act) {
        act = best;
        items.forEach(function (it, k) { it.classList.toggle('is-act', k === best); });
        dotEls.forEach(function (e, k) { e.classList.toggle('is-on', k === best); });
      }
      var max = tr.scrollWidth - tr.clientWidth - 2;
      if (prev) { prev.disabled = tr.scrollLeft <= 2; }
      if (next) { next.disabled = tr.scrollLeft >= max; }
      car.classList.toggle('is-over', max > 4);
    }
    function queue() { if (!queued) { queued = true; (window.requestAnimationFrame || window.setTimeout)(mark); } }
    function go(dir) {
      var step = (items[0].offsetWidth + 20) * dir;
      if (tr.scrollBy) { tr.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' }); } else { tr.scrollLeft += step; }
    }
    tr.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    if (prev) { prev.addEventListener('click', function () { go(-1); }); }
    if (next) { next.addEventListener('click', function () { go(1); }); }
    mark();
  });

  /* como funciona: passos clicáveis, que avançam sozinhos enquanto ninguém mexe */
  $$('[data-how]').forEach(function (root) {
    var steps = $$('[data-how-step]', root), txt = $('[data-how-text]', root), cur = 0, timer = null, auto = root.hasAttribute('data-autoplay') && !reduce;
    if (!steps.length) { return; }
    function show(n) {
      cur = (n + steps.length) % steps.length;
      steps.forEach(function (b, k) { b.classList.toggle('is-on', k === cur); b.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
      if (txt) {
        txt.textContent = steps[cur].getAttribute('data-text') || '';
        txt.classList.remove('is-in');
        void txt.offsetWidth;
        txt.classList.add('is-in');
      }
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function play() { stop(); if (auto) { timer = window.setInterval(function () { show(cur + 1); }, 3800); } }
    steps.forEach(function (b, k) { b.addEventListener('click', function () { auto = false; stop(); show(k); }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { play(); } else { stop(); } });
      }, { threshold: 0.35 }).observe(root);
    } else { play(); }
  });

  /* vídeos (Eisfit em ação) */
  $$('[data-video]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sec = btn.closest('section'), dlg = sec && $('[data-vd]', sec), body = dlg && $('[data-vd-body]', dlg), src = btn.getAttribute('data-video');
      if (!dlg || !body || !src) { return; }
      var yt = src.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
      body.innerHTML = yt
        ? '<iframe src="https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1" title="Vídeo" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>'
        : '<video src="' + src.replace(/"/g, '&quot;') + '" controls autoplay playsinline></video>';
      if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    });
  });
  $$('[data-vd]').forEach(function (dlg) {
    function clear() { var b = $('[data-vd-body]', dlg); if (b) { b.innerHTML = ''; } }
    $('[data-vd-x]', dlg).addEventListener('click', function () { clear(); if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); } });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) { clear(); if (dlg.close) { dlg.close(); } } });
    dlg.addEventListener('close', clear);
  });

  /* página com todas as avaliações: mostra 12 e libera mais 12 a cada clique (sem JavaScript, aparecem todas) */
  $$('[data-rv-grid]').forEach(function (grid) {
    var step = parseInt(grid.getAttribute('data-step'), 10) || 12,
        items = $$('.rv-gi', grid), shown = step,
        box = d.createElement('div'), more = d.createElement('button');
    if (items.length <= step) { return; }
    box.className = 'car-foot';
    more.type = 'button';
    more.className = 'btn btn--volt';
    box.appendChild(more);
    grid.parentNode.insertBefore(box, grid.nextSibling);
    function paint() {
      var left = items.length - shown;
      items.forEach(function (it, i) { it.hidden = i >= shown; });
      if (left <= 0) { box.hidden = true; return; }
      more.textContent = 'Mostrar mais avaliações (' + left + ')';
    }
    more.addEventListener('click', function () {
      var first = items[shown], card;
      shown += step;
      paint();
      card = first && $('.rv', first);
      if (card) { card.setAttribute('tabindex', '-1'); card.focus(); }
    });
    paint();
  });
});